import React, { useState } from 'react';

const N  = '#0A2540';
const E  = '#7C4DFF';

const projects = [
  {
    title: 'Women & Youth Economic Empowerment in Fisheries',
    donor: 'Mastercard Foundation / TradeMark Africa / AfCFTA',
    period: '2024 – Present',
    countries: ['Kenya', 'Tanzania', 'DRC', 'Uganda', 'Zambia', 'Nigeria'],
    tags: ['Financial Inclusion', 'Youth Empowerment', 'Value Chain'],
    color: E,
    desc: 'Multi-country program developing inclusive market access for women and youth in the fisheries value chain. Involves financial literacy modules, stakeholder engagement, and technical assistance to financial institutions.',
  },
  {
    title: 'Productive Credit to Women in Kenya & Uganda',
    donor: 'Bill & Melinda Gates Foundation',
    period: '2024 – Present',
    countries: ['Kenya', 'Uganda'],
    tags: ['Women Finance', 'Credit Access', 'MSEs'],
    color: '#2D7BE4',
    desc: 'Five-year program providing technical support for product development, structuring financial products, and integrating mobile money solutions to expand credit access for women in marginalized regions.',
  },
  {
    title: 'CICO & Order-Now-Pay-Later for Wasoko Merchants',
    donor: 'Gates Foundation',
    period: '2024 – 2025',
    countries: ['Tanzania'],
    tags: ['Digital Finance', 'VAS', 'Merchants'],
    color: '#7C4DFF',
    desc: 'Research project evaluating Value-Added Services (CICO and ONPL) feasibility on the Wasoko platform. Led primary research, KII with regulators, and analysis to guide VAS strategy development.',
  },
  {
    title: 'NCBA Now – Security & Customer Experience Upgrade',
    donor: 'NCBA Bank (Internal)',
    period: '2022',
    countries: ['Kenya'],
    tags: ['Banking Tech', '2FA', 'Product Testing'],
    color: '#FF6B35',
    desc: 'Improved customer experience and security through USSD 2FA implementation, menu updates, and card management features (E-Pin). Served as product tester collaborating with PM and DevOps teams.',
  },
  {
    title: 'NCBA Now Unit Trust Digitization',
    donor: 'NCBA Bank (Internal)',
    period: '2022 – 2023',
    countries: ['Kenya'],
    tags: ['FinTech', 'Mobile Banking', 'Unit Trust'],
    color: '#E53E3E',
    desc: 'Integrated Unit Trust Funds into the NCBA Now Mobile Banking App. As test analyst, validated portfolio registration, sub-account creation, transfers, liquidation, and statement features.',
  },
  {
    title: 'DREAMS – USAID/PEPFAR HIV Prevention Program',
    donor: 'USAID / PEPFAR',
    period: '2020 – 2022',
    countries: ['Kenya'],
    tags: ['AGYW', 'HIV Prevention', 'Economic Empowerment'],
    color: '#6030E8',
    desc: 'Instructional facilitator delivering HIV prevention, financial capability, and economic empowerment programs to 700+ adolescent girls and young women. Enrolled AGYWs in vocational training.',
  },
];

export default function Projects() {
  const [hovered, setHovered] = useState(null);

  return (
    <section id="projects" className="section section-alt">
      <div className="container">
        <div className="section-header">
          <h2>Key Projects</h2>
          <div className="section-divider" />
          <p style={{ marginTop: 12 }}>Donor-funded and institutional programs delivered across Sub-Saharan Africa.</p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
          {projects.map((p, i) => (
            <div key={i}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              style={{
                background: '#fff', borderRadius: 14, overflow: 'hidden',
                border: `1px solid ${hovered === i ? p.color : '#E2E8F0'}`,
                boxShadow: hovered === i ? `0 8px 30px ${p.color}28` : '0 2px 12px rgba(10,37,64,0.07)',
                transition: 'all 0.3s', transform: hovered === i ? 'translateY(-4px)' : 'none',
              }}
            >
              {/* Color accent bar */}
              <div style={{ height: 5, background: p.color }} />

              <div style={{ padding: 24 }}>
                {/* Donor badge */}
                <div style={{
                  fontSize: '0.75rem', color: p.color, fontWeight: 700,
                  marginBottom: 10, letterSpacing: '0.5px',
                }}>
                  <i className="fas fa-building" style={{ marginRight: 6 }} />
                  {p.donor}
                </div>

                <h3 style={{ fontSize: '1rem', fontWeight: 700, color: N, marginBottom: 10, lineHeight: 1.4 }}>
                  {p.title}
                </h3>
                <p style={{ color: '#718096', fontSize: '0.85rem', lineHeight: 1.7, marginBottom: 16 }}>
                  {p.desc}
                </p>

                {/* Tags */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 16 }}>
                  {p.tags.map(t => (
                    <span key={t} style={{
                      background: `${p.color}14`, color: p.color,
                      border: `1px solid ${p.color}32`,
                      padding: '3px 10px', borderRadius: 20, fontSize: '0.75rem', fontWeight: 600,
                    }}>
                      {t}
                    </span>
                  ))}
                </div>

                {/* Footer */}
                <div style={{
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  borderTop: '1px solid #F0F4F8', paddingTop: 12, marginTop: 4,
                }}>
                  <span style={{ color: '#718096', fontSize: '0.8rem' }}>
                    <i className="fas fa-calendar-alt" style={{ marginRight: 6, color: E }} />{p.period}
                  </span>
                  <span style={{ color: '#718096', fontSize: '0.78rem' }}>
                    <i className="fas fa-map-marker-alt" style={{ marginRight: 4, color: E }} />
                    {p.countries.join(', ')}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 992px) {
          #projects .container > div:last-child { grid-template-columns: repeat(2, 1fr) !important; }
        }
        @media (max-width: 600px) {
          #projects .container > div:last-child { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
